import { Col, Form, Input, Row } from 'antd'
import { GetFieldDecoratorOptions } from 'antd/lib/form/Form'
import * as React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { WeekHoursEditor } from 'src/components/weekhours-editor'
import { nameof } from 'src/core/utils/object'
import { NewRestrictionPlanItem } from 'src/stores/restriction-plans-store'
import { RestrictionPlanFormItem } from './utils'

let FormItem = Form.Item

interface ClassFormBodyProps extends WithTranslation {
    item: RestrictionPlanFormItem | undefined
    onSave?: () => Promise<any>
    getFieldDecorator<T extends Object = {}>(
        id: keyof T,
        options?: GetFieldDecoratorOptions
    ): (node: React.ReactNode) => React.ReactNode
    disabled?: boolean
}


export class RestrictionPlanFormBody extends React.Component<ClassFormBodyProps> {

    render() {
        const { t } = this.props
        var item = this.props.item || ({} as NewRestrictionPlanItem)

        return (
            <>
                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem label={t('Restriction Plan Name')}>
                            {this.props.getFieldDecorator(
                                nameof<NewRestrictionPlanItem>('displayName'),
                                {
                                    initialValue: item.displayName,
                                    rules: [{ required: true, message: t('Restriction plan must have a name') }]
                                }
                            )(
                                <Input
                                    disabled={this.props.disabled}
                                    placeholder={t('Insert name for this restriction plan')}
                                    type="text"
                                />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem>
                            {this.props.getFieldDecorator(
                                'hourRestrictions',
                                {
                                    initialValue: this.props.item?.hourRestrictions,
                                }
                            )(
                                <WeekHoursEditor
                                    disabled={this.props.disabled}
                                    i18n={this.props.i18n}
                                    t={this.props.t}
                                    tReady={this.props.tReady}
                                />
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </>
        )
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(RestrictionPlanFormBody);
